import { takeEvery, put, select } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';
import { Action } from 'redux';

import { getCaptcha, fetchCaptchaToken, getAudioCaptcha } from 'ApiPackage/CaptchaModule/services/captcha';
import { IResponseError } from 'ApiPackage/MainModule/interfaces/IResponseError';
import { coreShowNotice } from 'CorePackage/MainModule/actions/coreActions';
import { INTERNAL_SERVER_ERROR } from 'CorePackage/MainModule/constants/notices';
import { NoticeTypesEnum } from 'CorePackage/MainModule/enums/NoticeTypesEnum';
import { sagaWrapper } from 'CorePackage/MainModule/common/sagaWrapper';

import { CaptchaActionsEnum } from '../enums/CaptchaActionsEnum';
import { convertFileToBase64 } from '../common/convertFileToBase64';
import { getCaptchaActionAfterLoad } from '../selectors/captchaSelectors';
import {
  captchaRequest,
  captchaSuccess,
  captchaSetIsActive,
  captchaSetError,
  captchaSetImage,
  captchaGetImage,
  captchaSetAudio,
  captchaLoad,
} from '../actions/captchaActions';

function* captchaGetImageSaga() {
  function* funcTry() {
    const image: Blob = yield getCaptcha();
    const imageUrl = URL.createObjectURL(image);
    yield put(captchaSetImage(imageUrl));
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* captchaLoadSaga(action: ActionType<typeof captchaLoad>) {
  function* funcTry() {
    const { captchaInputValue } = action.payload;
    const actionAfterLoad: (() => Action<unknown>) | undefined = yield select(getCaptchaActionAfterLoad);
    yield put(captchaRequest());
    const result: string = yield fetchCaptchaToken(captchaInputValue);
    yield put(captchaSuccess(result));
    localStorage.setItem('captcha', result);
    yield put(captchaSetIsActive(false));
    if (actionAfterLoad) {
      yield put(actionAfterLoad());
    }
  }

  yield sagaWrapper({
    funcTry,
    *funcCatch(err: IResponseError) {
      if (err?.status === 500) {
        yield put(coreShowNotice(INTERNAL_SERVER_ERROR, NoticeTypesEnum.ERROR));
      } else if (err.status !== 500) {
        yield put(captchaSetError('Неверное проверочное значение'));
      }
      yield put(captchaGetImage());
    },
  });
}

function* captchaGetAudioSaga() {
  function* funcTry() {
    const audio: Blob = yield getAudioCaptcha();
    const audioBase64: string = yield convertFileToBase64(audio);
    yield put(captchaSetAudio(audioBase64));
  }

  yield sagaWrapper({
    funcTry,
  });
}

export function* watchCaptchaSaga() {
  yield takeEvery(CaptchaActionsEnum.CAPTCHA_LOAD, captchaLoadSaga);
  yield takeEvery(CaptchaActionsEnum.CAPTCHA_GET_IMAGE, captchaGetImageSaga);
  yield takeEvery(CaptchaActionsEnum.CAPTCHA_GET_AUDIO, captchaGetAudioSaga);
}
